import React, { useContext, useMemo } from "react";
import { BannerContext } from "../../context";
import { ContentDirections } from "../../config";
import UpToDown from "./types/UpToDown";
import LeftToRight from "./types/LeftToRight";
import { Hidden, Visible } from "react-grid-system";

const Directions = {
  [ContentDirections.LTR]: LeftToRight,
  [ContentDirections.UTD]: UpToDown,
  [undefined]: undefined,
};

function EmptyOrder() {
  const { globalConfig } = useContext(BannerContext);
  const { contentDirection } = globalConfig;

  const Component = useMemo(
    () => Directions[contentDirection] || UpToDown,
    [contentDirection]
  );

  return (
    <>
      <Visible xs>
        <UpToDown />
      </Visible>
      <Hidden xs>
        <Component />
      </Hidden>
    </>
  );
}

export default EmptyOrder;
